import React from 'react';
import { LoadingOverlayStyles, RegionLoadingOverlayStyles } from '../styles/LoadingOverlay.styles';
import Spinner from '../../../../common/Spinner/Spinner';
import { useSelector } from 'react-redux';
import { isOnMapClickState, isRegionDataLoadingState } from '../../../../../app/redux/retrievers/retrievers';

interface LoadingOverlayProps {
    isLoading: boolean;
}
const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isLoading }) => {
    const isRegionDataLoading = useSelector(isRegionDataLoadingState);
    const isOnMapClick = useSelector(isOnMapClickState);

    return (
        <>
            {/*isLoading ||*/}
            {(isRegionDataLoading || (isLoading && isOnMapClick)) && (
                <div
                    style={
                        isLoading && !isOnMapClick
                            ? LoadingOverlayStyles.Overlay
                            : isRegionDataLoading || isOnMapClick
                            ? RegionLoadingOverlayStyles.Overlay
                            : {}
                    }
                >
                    <div>
                        <Spinner isLoading={true} margin=" auto" />
                        {isRegionDataLoading && (
                            <div style={{ textAlign: 'center' }}>
                                <div>
                                    <strong>...لطفا منتظر بمانید</strong>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default LoadingOverlay;
